import { render, staticRenderFns } from "./UnderstandButton.vue?vue&type=template&id=02b4ff11&"
import script from "./UnderstandButton.vue?vue&type=script&lang=js&"
export * from "./UnderstandButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports